import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import App from '@app';
import { Button, Form, Input, Row, Col, Icon } from '@components';
import { InfoUsuario } from '@utils';
import { login, reset } from '@ducks/login';

const Content = styled(Row)`
  flex: 1;
`;

const LoginForm = styled(Form)`
  margin: 24px;
  background-color: #fff;
  padding: 16px;
  border-radius: 5px;
  padding-bottom: 4px;
`;

const Title = styled.div`
  text-align: center;
  font-size: 20px;
`;

export default function Login({ history }) {
  const dispatch = useDispatch();
  const location = useLocation();

  const loading = useSelector(({ login }) => login.get('loading'));
  const success = useSelector(({ login }) => login.get('success'));

  useEffect(() => {
    if (InfoUsuario.hasUser()) {
      history.replace('/');
    }
    return () => dispatch(reset());
  }, []);

  useEffect(() => {
    if (success) {
      if (location.state && location.state.pathname) {
        history.replace(location.state.pathname, location.state);
      } else {
        history.replace('/');
      }
    }
  }, [success]);

  const handleLogin = ({ username, password }) => {
    dispatch(login(username, password));
  };

  return (
    <App>
      <Content>
        <Col
          xs={{ span: 24 }}
          md={{ span: 16, offset: 4 }}
          lg={{ span: 14, offset: 5 }}
          xl={{ span: 10, offset: 7 }}
          xxl={{ span: 6, offset: 9 }}
        >
          <LoginForm hideRequiredMark layout="vertical" onFinish={handleLogin}>
            <Title>Dev</Title>
            <Form.Item
              label="Usuário"
              name="username"
              rules={[{ required: true, message: 'Informe o usuário' }]}
              prefix={<Icon.UserOutlined />}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Senha"
              name="password"
              rules={[{ required: true, message: 'Informe a senha' }]}
              prefix={<Icon.LockOutlined />}
            >
              <Input.Password />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" block loading={loading}>
                Entrar
              </Button>
            </Form.Item>
          </LoginForm>
        </Col>
      </Content>
    </App>
  );
}
